<div class="spaces-overview">
  <div class="search-row">
    <label class="search-label" for="spaces-search">{{ 'SPACES_TABLE.SEARCH' | translate }}</label>
    <div class="search-field">
      <input
        id="spaces-search"
        type="text"
        [(ngModel)]="searchQuery"
        [placeholder]="'SPACES_TABLE.SEARCH_PLACEHOLDER' | translate" />
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 19L14.65 14.65" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <div class="table-wrap">
    <div class="table-row table-header-row">
      <div class="cell cell-name"><span>{{ 'SPACES_TABLE.SPACE_NAME' | translate }}</span></div>
      <div class="cell cell-owner"><span>{{ 'SPACES_TABLE.OWNER_NAME' | translate }}</span></div>
      <div class="cell cell-date"><span>{{ 'SPACES_TABLE.DATE_CREATED' | translate }}</span></div>
      <div class="cell cell-icon"></div>
      <div class="cell cell-icon"></div>
      <div class="cell cell-icon cell-icon-last"></div>
    </div>

    <div class="table-body">
      @for (space of filteredSpaces; track space) {
        <div class="table-row table-data-row">
          <div class="cell cell-name">
            <button class="space-link" (click)="onViewDetails(space)">{{ space.name }}</button>
          </div>
          <div class="cell cell-owner">{{ space.ownerName }}</div>
          <div class="cell cell-date">{{ space.dateCreated | date:'dd.MM.yyyy' }}</div>
          <div class="cell cell-icon">
            <button class="icon-btn" [title]="'ACTIONS.EXPORT_PDF' | translate" [disabled]="isExporting" (click)="exportPdf(space)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.46967 21.5303C1.32902 21.3897 1.25 21.1989 1.25 21L1.25 16C1.25 15.5858 1.58579 15.25 2 15.25C2.41421 15.25 2.75 15.5858 2.75 16L2.75 20.25L21.25 20.25L21.25 16C21.25 15.5858 21.5858 15.25 22 15.25C22.4142 15.25 22.75 15.5858 22.75 16L22.75 21C22.75 21.1989 22.671 21.3897 22.5303 21.5303C22.3897 21.671 22.1989 21.75 22 21.75L2 21.75C1.80109 21.75 1.61032 21.671 1.46967 21.5303Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.25 4C9.25 3.58579 9.58579 3.25 10 3.25L14 3.25C14.4142 3.25 14.75 3.58579 14.75 4L14.75 10.25H17C17.291 10.25 17.5558 10.4183 17.6792 10.6819C17.8026 10.9454 17.7625 11.2566 17.5762 11.4801L12.5762 17.4801C12.4337 17.6511 12.2226 17.75 12 17.75C11.7774 17.75 11.5663 17.6511 11.4238 17.4801L6.42383 11.4801C6.23753 11.2566 6.19737 10.9454 6.32081 10.6819C6.44424 10.4183 6.70899 10.25 7 10.25H9.25L9.25 4ZM10.75 4.75V11C10.75 11.4142 10.4142 11.75 10 11.75H8.60128L12 15.8285L15.3987 11.75H14C13.5858 11.75 13.25 11.4142 13.25 11V4.75H10.75Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <div class="cell cell-icon">
            <button class="icon-btn" [title]="'ACTIONS.SHARE_SPACE' | translate" (click)="shareSpace(space)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="18" cy="5" r="3"/>
                <circle cx="6" cy="12" r="3"/>
                <circle cx="18" cy="19" r="3"/>
                <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/>
                <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/>
              </svg>
            </button>
          </div>
          <div class="cell cell-icon cell-icon-last">
            <button class="icon-btn" [title]="'ACTIONS.DELETE_SPACE' | translate" (click)="confirmDeleteSpace(space)">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M3 6h18"/>
                <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                <line x1="10" x2="10" y1="11" y2="17"/>
                <line x1="14" x2="14" y1="11" y2="17"/>
              </svg>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
